import { trackCtaClick } from '../lib/gtag';

type Props = {
  badge: string;
  text: string;
  arrow?: boolean;
  trackLocation?: string;
} & (
  | { as?: 'a'; href: string; onClick?: never; disabled?: never; type?: never }
  | { as: 'button'; href?: never; onClick?: () => void; disabled?: boolean; type?: 'button' | 'submit' | 'reset' }
);

export default function CtaButton({ badge, text, arrow, trackLocation, ...rest }: Props) {
  const cls = `lp__floating-cta${arrow ? ' lp__floating-cta--arrow' : ''}`;

  const handleTrack = () => {
    if (trackLocation) trackCtaClick(text, trackLocation);
  };

  const inner = (
    <>
      <span className="lp__floating-cta__body">
        <span className="lp__floating-cta__badge">{badge}</span>
        <span className="lp__floating-cta__text">{text}</span>
      </span>
      {arrow && <span className="lp__floating-cta__arrow">↗</span>}
    </>
  );

  if (rest.as === 'button') {
    return (
      <button className={cls} type={rest.type ?? 'button'} disabled={rest.disabled} onClick={() => { handleTrack(); rest.onClick?.(); }}>
        {inner}
      </button>
    );
  }

  return (
    <a href={rest.href} className={cls} onClick={handleTrack}>
      {inner}
    </a>
  );
}
